import PartnerApplicationsPage from "./PartnerApplicationsPage";
import PartnerClientsPage from "./PartnerClientsPage";
import PartnerStatisticsPage from "./PartnerStatisticsPage";
import PartnerPaymentsPage from "./PartnerPaymentsPage";
import PartnerMessagesPage from "./PartnerMessagesPage";
export const partnerPageComponents = { clients: PartnerClientsPage, statistics: PartnerStatisticsPage, applications: PartnerApplicationsPage, payments: PartnerPaymentsPage, messages: PartnerMessagesPage };
